/* eslint-disable react/jsx-pascal-case */
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import React, { Fragment } from 'react';
import { Grid, HLine, MHeading, MarginHandler } from '../../styledComponents';
import { colors } from '../../utils';
import { Box_, Footer, Header } from './styledComponent';
import ButtonCom from '../button/ButtonCom';

const { colorWhite, colorLightBlack, colorPrimary } = colors;

export default function DeleteModal({
	children,
	open,
	handleClose,
	handleDelete,
	padding,
	handleClassName,
	width,
	height,
}) {

	return (
		<div>
			<Modal
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}

				style={{ zIndex: '99999 !important' }}>
				<Fade in={open}>
					<Box_ style={{ width: width, height: height, zIndex: '99999 !important' }} className={handleClassName}>

						{/* <Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem' style={{ paddingBottom: "0" }}> */}

						<Header padding={padding} id='transition-modal-title'>
							<MHeading fs='1.8rem' fw='600'>
								Delete
							</MHeading>
							<IconButton aria-label='close' onClick={handleClose}>
								<CloseIcon style={{ color: colorWhite, fontSize: '2rem' }} />
							</IconButton>
						</Header>
						{/* <Fragment>{children}</Fragment> */}
						<Typography sx={{ padding: "1em" }} variant='h4'>Are you sure you want to delete ?</Typography>

						<Footer>

							<Box sx={{ display: "flex", justifyContent: "right" }}>

								<MarginHandler>
									{/* <ButtonCom onClickHandler={handleClose} btnTitle={"No"} /> */}
									<Button className='font-face-M' variant='contained' color='inherit' sx={{ padding: "1rem", fontSize: "1.4em", borderRadius: "0.5rem" }} onClick={handleClose} >No</Button>
								</MarginHandler>
								<MarginHandler ml="12px">
									<ButtonCom onClickHandler={handleDelete} btnTitle={"Yes"} />
								</MarginHandler>

							</Box>

						</Footer>
						{/* </Grid> */}
					</Box_>
				</Fade>
			</Modal>
		</div>
	);
}
